import { put, select, takeLatest, takeLeading } from 'redux-saga/effects';
import { sessionRefreshRejected } from '@icebreaker/shared/store';
import type { RootState } from '@/shared/store/store';
import * as authApi from '../api/auth.api';
import {
  restoreSession,
  sessionExpired,
  signOut,
  staffLogin,
  staffSetup,
  staffVerify,
} from './auth.slice';
import { createPanelApiSaga } from './panel-api-saga';

/**
 * Jenerik `apiSaga` sarmalayıcısı: try/catch, jeton yenileme ve hata
 * normalizasyonu TEK yerde (CLAUDE.md redux-saga kuralı 3).
 */
const apiSaga = createPanelApiSaga();

/**
 * YENİLEME REDDEDİLDİ (panel küçük işler 1 · B-02, web'deki sıra 45 deseni).
 * Korumalı istek 401 aldı, `apiSaga` bir kez yeniledi, yenileme ucu da
 * reddetti. Oturumlu sekmede oturum sınırı geçilir ve kapı giriş ekranına
 * götürür. Aynı anda düşen istekler tek kapanış üretir: ilk kapanıştan sonra
 * `isAuthenticated` düşmüştür (`takeLeading` + seçici).
 */
function* onSessionRefreshRejected() {
  const authenticated = (yield select((state: RootState) => state.auth.isAuthenticated)) as boolean;
  if (authenticated) yield put(sessionExpired());
}

export function* authSaga() {
  yield takeLeading(sessionRefreshRejected.type, onSessionRefreshRejected);
  yield takeLatest(
    staffLogin.request.type,
    apiSaga(staffLogin, authApi.staffLogin, { retryOnUnauthorized: false }),
  );
  yield takeLatest(
    staffVerify.request.type,
    apiSaga(staffVerify, authApi.staffVerify, { retryOnUnauthorized: false }),
  );
  yield takeLatest(
    staffSetup.request.type,
    apiSaga(staffSetup, authApi.staffSetup, { retryOnUnauthorized: false }),
  );
  yield takeLatest(
    restoreSession.request.type,
    apiSaga(restoreSession, authApi.restoreSession, { retryOnUnauthorized: false }),
  );
  yield takeLatest(signOut.request.type, apiSaga(signOut, authApi.signOut));
}
